import React from 'react'

import MainLayout from '@/Layouts/MainLayout/MainLayout'
import MainContentBody from '@/Layouts/MainLayout/components/MainContentBody'
import ArchivedProjects from '@/Pages/HomePage/tabs/ArchivedProjects'

const OtherProjectsPage = () => (
  <MainLayout menuName="homepage" subMenuName="other_projects">
    <MainContentBody>
      <ArchivedProjects />
    </MainContentBody>
  </MainLayout>
)

export default OtherProjectsPage
